// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.7-0-gc545cfbb",
    "hash": "gc545cfbb",
    "distance": 0,
    "tag": "v1.0.7",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.7",
        "major": 1,
        "minor": 0,
        "patch": 7,
        "prerelease": [],
        "build": [],
        "version": "1.0.7"
    },
    "suffix": "0-gc545cfbb",
    "semverString": "1.0.7",
    "version": "1.0.7"
};
